import React from "react"
import { Button } from 'primereact/button';
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { CallOutBox, FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Callbacks } from "jquery";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, odsCallOutBoxs } from "../../entities/Constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";


interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;

}

export class DialogForDateTimeComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

        let subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'DateTime' && p.Sequence < this.props.ele.Sequence);
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Business Rule for " + this.props.ele.ENUTitle : "Business Rule for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    otherPreviousDateFields = () => {
        let htmlString = [];

        htmlString.push(
            <div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '40%' }}>
                        <label htmlFor={"tbl_" + this.props.ele.Sequence}>Update Binding Field</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"tbl_" + this.props.ele.Sequence} value={this.props.ele.UpdateField} className="ontario-input"
                            onChange={(e) => { this.props.ele.UpdateField = e.target.value; this.props.callback() }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '40%' }}>
                        <label htmlFor={"tbl_" + this.props.ele.Sequence}>Custom Error Message</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"tbl_" + this.props.ele.Sequence} value={this.props.ele.ErrorMessage} className="ontario-input"
                            onChange={(e) => { this.props.ele.ErrorMessage = e.target.value; this.props.callback() }} />
                    </div>
                </div>
                
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '40%' }}>
                        {/* @ts-ignore */}
                        <Dropdown  className="ontario-dropdown" options={dateComparisonList} optionLabel='label' optionValue='val' value={this.props.ele.ValidateCompareMethod} onChange={(e) => {
                            this.props.ele.ValidateCompareMethod = e.value;
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown  className="ontario-dropdown" options={this.dateTypeFieldList} optionLabel='ENUTitle' optionValue='LoadBindName' value={this.props.ele.ValidateCompareField} onChange={(e) => {
                            this.props.ele.ValidateCompareField = e.value;
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '40%' }}>Hint Expansion Title</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.ele.hintExpansionTitle}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.hintExpansionTitle = e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div>

                {/* Alert box options */}
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '40%' }}>Callout Box</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown  className="ontario-dropdown" options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e) => {
                            this.props.ele.callOutBoxType = e.value;
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '40%' }}>Callout Box Title</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={ this.props.isEng? this.props.ele.callOutBoxTitle:this.props.ele.callOutBoxTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.callOutBoxTitle = e.target.value;
                            else
                                this.props.ele.callOutBoxTitleFRA = e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '40%' }}>Callout Box Body Message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.callOutBoxBody = e.htmlValue;
                                else
                                    this.props.ele.callOutBoxBodyFRA = e.htmlValue;
                                this.props.callback();
                            }}></Editor>
                    </div>
                </div>

            </div>
        )
        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
